import env from '~/libs/env'
import {useUserStore} from '~/store/user'
import {
  type DocumentCategoryType,
  type DocumentVerificationsResponse,
  type DocumentIntelligenceConfigResponse,
  LogLevel
} from '~/libs/document-intelligence-types'
import {docIntelligenceLog} from '~/libs/document-intelligence-helper'

export function useDocIntelligenceApi() {
  const userStore = useUserStore()

  return {
    fetchDocumentIntelligenceConfig: (borrowerId: number): Promise<DocumentIntelligenceConfigResponse | null> => {
      if (!import.meta.client) {
        return
      }

      const authHeader = userStore.getAuthHeader({useCookies: true})

      if (!authHeader) {
        throw new Error('No authentication header available')
      }
      return $fetch(`${env('apiUrl')}/borrowers/${borrowerId}/document-intelligence-config`, {
        headers: {
          Authorization: authHeader,
        },
        retry: 3,
        retryDelay: 100,
        timeout: 3000,
        onResponseError({response, error}) {
            docIntelligenceLog(
              '[fetchDocumentIntelligenceConfig onResponseError] Error fetching document intelligence config:',
              LogLevel.ERROR, {error, status: response.status, body: response._data, borrowerId,}
            )
        }
      });
    },
    fetchDocumentVerifications: (
      documentCategories: DocumentCategoryType[],
      borrowerId: number,
      signal?: AbortSignal
    ): Promise<DocumentVerificationsResponse | null>  => {
      if (!import.meta.client) {
        return
      }

      const authHeader = userStore.getAuthHeader({useCookies: true})

      if (!authHeader) {
        throw new Error('No authentication header available')
      }

      return $fetch(`${env('apiUrl')}/borrowers/${borrowerId}/documents/verifications`, {
        query: {
          'documentCategories[]': documentCategories,
        },
        headers: {
          Authorization: authHeader,
        },
        signal,
        retry: 3,
        retryDelay: 100,
        timeout: 3000,
        onRequestError({request, error}) {
          if(error?.name !== 'AbortError' && !signal?.aborted) {
            docIntelligenceLog(
              '[fetchDocumentVerifications onRequestError] Error fetching document verifications:',
              LogLevel.ERROR,
              {error, request, borrowerId, documentCategories}
            )
          }
        },
        onResponseError({response, error}) {
          if(error?.name !== 'AbortError' && !signal?.aborted) {
            docIntelligenceLog(
              '[fetchDocumentVerifications onResponseError] Error fetching document verifications:',
              LogLevel.ERROR,
              {
                error,
                status: response.status,
                body: response._data,
                borrowerId,
                documentCategories
              }
            )
          }
        }
      });
    },
  }
}
